<template>
  <v-container id="asistenciaalumnosec-ivt">
    <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="info"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>NIVEL SECUNDARIO - ASISTENCIA DE ESTUDIANTES POR CURSO</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="CargaDivisiones"
                    class="ocupa30"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="filtros.iddivision"
                    :items="listadivisiones"
                    label="División"
                    item-text="divisioncompleta"
                    item-value="iddivision"
                    no-data-text="Sin Divisiones"
                    height="20px"
                    v-on:change="Listar"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Listar Asistencias"
                      @click="Listar"
                      :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                      class="ma-2"
                      x-small
                      color="blue"
                      title="Nueva Asistencia"
                      @click="agregar"
                      :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="lista.length"
                    hide-default-footer
                    item-key="idasistencia"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                  >
                    <template v-slot:item.fechadmy="{ item }">
                      <v-btn text color="primary" @click="editarasistencia(item)">
                        {{ item.fechadmy }}
                      </v-btn>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            color="green"
                            @click="Imprimir(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span>Imprimir</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogmensaje = false;if (mensajehome === true) {$router.push('Home');}"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogasistencia" persistent full-width>
      <v-card>
        <v-card-title class="headline">
          {{ dialogasistenciatitulo }}
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <v-btn color="green darken-1" text @click="guardar">
                Guardar
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogasistencia = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
        <v-card-text>
          <br />
          <br />
          <v-row class="text-center">
            <v-col cols="12">
              <p class="titulodialog">{{editacurtitulo}}</p>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-menu
                v-model="menufecha"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechalocalfecha"
                    label="Fecha"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    :disabled="edita"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="edited.fecha"
                  @input="menufecha = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea name="input-5-1"
                v-model="edited.observacion"
                label="Temario"
                rows="2"
                row-height="15"
              />
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12">
              <v-data-table
                :headers="columnasasisalu"
                :items="edited.listaasisalu"
                :items-per-page="edited.listaasisalu.length"
                hide-default-footer
                item-key="idalumno"
                class="elevation-1"
                dense
                no-data-text="Sin Registros"
              >
                <template v-slot:item.asistio="{ item }">
                  <v-checkbox
                    v-model="item.asistio"
                    v-on:change="seleccionaasistencia(item)"
                  ></v-checkbox>
                </template>
                <template v-slot:item.justificado="{ item }">
                  <v-checkbox
                    v-model="item.justificado"
                    :disabled="item.asistio===true"
                  ></v-checkbox>
                </template>
                <template v-slot:item.motivoinasistencia="{ item }">
                  <v-text-field
                    v-model="item.motivoinasistencia"
                    label="Motivo"
                    :disabled="item.asistio===true"
                  ></v-text-field>
                </template>
              </v-data-table>
              <br />
              <br />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "asistenciaalumnosec",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 27,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 100
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechadmy",
          width: 90
        },
        /* {
          text: "Docente",
          align: "center",
          sortable: true,
          value: "docente",
          width: 150
        }, */
        {
          text: "División",
          align: "center",
          sortable: true,
          value: "division",
          width: 100
        }
      ],
      lista: [],
      filtros: {
        idcarrera: 0,
        anio: 0,
        iddocente: 0,
        idasignatura: 0,
        iddivision: 0
      },
      listaasignaturas: [],
      listacarreras: [],
      listaanios: [],
      dialogasistencia: false,
      dialogasistenciatitulo: '',
      listadivisiones: [],
      menufecha: false,
      edited: {
        idasistencia: 0,
        iddocente: 0,
        idasignatura: 0,
        iddivision: 0,
        anio: 0,
        fecha:'',
        observacion: '',
        listaasisalu: [],
        usuario: ''
      },
      columnasasisalu: [
        {
          text: "Estudiante",
          align: "left",
          sortable: true,
          value: "apenom",
          width: 180
        },
        {
          text: "Documento",
          align: "center",
          sortable: true,
          value: "nrodoc",
          width: 100
        },
        {
          text: "Asistió",
          align: "left",
          value: "asistio",
          width: 70
        },
        {
          text: "Justificado",
          align: "center",
          value: "justificado",
          width: 80
        },
        {
          text: "Motivo Inas.",
          align: "left",
          value: "motivoinasistencia",
          width: 150
        }
      ],
      edita: false,
      editacurtitulo: ''
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
      if(this.roles.includes(7)) {
        this.filtros.iddocente= parseInt(localStorage.getItem("idpersona"));
      }else{
        this.filtros.iddocente= 0;
      }
      var i=0;
      var anioactual= (new Date()).getFullYear();
      for(i=2023;i<=anioactual;i++) {
        this.listaanios.push({anio: i});
      }
      this.filtros.anio= (new Date()).getFullYear();
      this.CargaDivisiones();
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar () {
      this.loading = true;
      var usuario= this.usuario;
      var anio= this.filtros.anio!=null ? this.filtros.anio : '0';
      var idcarrera= 7;
      var iddocente= 0;
      var idasignatura= 0; //this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel===3 || this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel===4 ? this.filtros.idasignatura!=null ? this.filtros.idasignatura : '0' : '0';
      //var iddivision= this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel!=4 ? this.filtros.iddivision!=null ? this.filtros.iddivision : '0' : '0';
      var iddivision= this.filtros.iddivision!=null ? this.filtros.iddivision : '0';
      axios.get('asistenciaalumno/listaasistencia/' + usuario + '/' + iddocente + '/' + idcarrera + '/' + anio + '/' + idasignatura + '/' + iddivision + '/0').then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    agregar () {
      this.loading=true;
      this.dialogasistenciatitulo='Nueva Asistencia';
      this.edita=false;
      var usuario= this.usuario;
      var iddocente= 0;
      var idasignatura= 0; //this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel===3 || this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel===4 ? this.filtros.idasignatura!=null ? this.filtros.idasignatura : '0' : '0';
      var iddivision= this.filtros.iddivision!=null ? this.filtros.iddivision : '0';
      var anio= this.filtros.anio;
      this.editacurtitulo= 'Nivel Secundario - Curso|División: ' + this.listadivisiones.filter(d=> d.iddivision===this.filtros.iddivision)[0].divisioncompleta + ' - Año: ' + this.filtros.anio.toString();
      
      axios.get('asistenciaalumno/editaasistencia/' + usuario + '/' + iddocente + '/0/' + anio + '/' + idasignatura + '/' + iddivision + '/0').then((result) => {
          if(result.data.resultado===0){
            this.edited= {
              idasistencia: 0,
              iddocente: parseInt(iddocente),
              idasignatura: parseInt(idasignatura),
              iddivision: parseInt(iddivision),
              anio: parseInt(anio),
              fecha: this.fechaFormatoYMD(new Date()),
              observacion: '',
              listaasisalu: result.data.datos,
              usuario: this.usuario
            };
            this.loading = false;
            this.dialogasistencia=true;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    editarasistencia (item) {
      this.loading=true;
      this.dialogasistenciatitulo='Edita Asistencia';
      this.edita=true;
      var usuario= this.usuario;
      var iddocente= 0; // this.filtros.iddocente!=null ? this.filtros.iddocente : '0';
      var idasignatura= 0; //item.idasignatura; //this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel===4 ? this.filtros.idasignatura!=null ? this.filtros.idasignatura : '0' : '0';
      var iddivision= item.idcatedra!=null ? item.iddivisionsuperior!=null ? item.iddivisionsuperior : '0' : item.iddivisioniniprisec!=null ? item.iddivisioniniprisec : '0'; //this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idnivel!=4 ? this.filtros.iddivision!=null ? this.filtros.iddivision : '0' : '0';
      var anio= this.filtros.anio;
      this.editacurtitulo= 'Nivel Secundario - Curso/División: ' + this.listadivisiones.filter(d=> d.iddivision===iddivision)[0].divisioncompleta + ' - ' + this.filtros.anio.toString();
      axios.get('asistenciaalumno/editaasistencia/' + usuario + '/' + iddocente + '/0/' + anio + '/' + idasignatura + '/' + iddivision + '/' + item.idasistencia).then((result) => {
          if(result.data.resultado===0){
            this.edited= {
              idasistencia: item.idasistencia,
              iddocente: parseInt(iddocente),
              idasignatura: parseInt(idasignatura),
              iddivision: parseInt(iddivision),
              anio: parseInt(anio),
              fecha: item.fechaymd,
              observacion: item.observacion,
              listaasisalu: result.data.datos,
              usuario: this.usuario
            };
            this.loading = false;
            this.dialogasistencia=true;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    guardar () {
      this.loading=true;
      var asistencia= JSON.stringify(this.edited);
      axios.post("asistenciaalumno/PostAsistencia",asistencia, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.dialogasistencia=false;
          this.Listar();
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    CargaDivisiones () {
      var parametros= JSON.stringify({idcarrera: 7, iddocente: this.filtros.iddocente, anio: this.filtros.anio, idasignatura: 0});
      axios.post("cursada/PostDivisionesXCarreraDocenteAnioAsignatura",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listadivisiones = result.data.datos;
          this.filtros.iddivision= this.listadivisiones.length>0 ? this.listadivisiones[0].iddivision : 0;
          this.Listar()
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    Imprimir (item) {
      this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 21, formato: 'PDF', nromodulo: this.nromodulo, usuario: this.usuario, listaparametros: [{ orden: 1, nombre: "idasistencia", valor: item.idasistencia.toString()} ] },{ headers: { "Content-Type": "application/json" }}).then((result) => {
        this.loading = false;
        if (result.data.toString().startsWith("Error") === false) {
          window.open(result.data, "_blank");
        } else {
          this.MostrarMensaje("Error", result.data, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    seleccionaasistencia (item) {
      if(item.asistio===true){
        item.motivoinasistencia='';
        item.justificado=false;
      }
    }
},
  computed: {
    fechalocalfecha: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.titulodialog {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>